import React from "react";
import styled from "styled-components";
import { useLocation, useParams } from "react-router-dom";
import FlowHeader from "@/features/results/FlowHeader";
import { MediaFileSection } from "@/features/results/MediaFileSection";
import { Content, MainContainer } from "@/styles/styles";
import { SideBar } from "@/components/nav/SideBar";
import { useNavigationStore } from "@/store/navigationStore";
import { useProcessVuStore } from "@/store/processVuStore";
import ScriptSection, {
  ScriptSectionTab,
} from "features/results/ContentSection";

export const FlowLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

export const FlowBody = styled.main`
  display: flex;
  flex: 1;
  min-height: 0;
  gap: 0;
`;

export const MediaSectionWrapper = styled.div`
  flex: 0 0 400px;
  min-height: 0;
  overflow: hidden;
  border-right: 1px solid #ebeef1;
`;

export const ScriptContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

const VU_TABS: ScriptSectionTab[] = ["전체 텍스트", "음원 분석", "감정 분석"];

const VU_TAGS = ["음원분리", "화자분리", "자막생성", "감정분석"];

const VoiceUnderstandingPage: React.FC = () => {
  const { projectId, documentId } = useParams<{
    projectId: string;
    documentId: string;
  }>();
  const location = useLocation();
  const { isCollapsed } = useNavigationStore();

  // 1. Try to get result from location state first (passed from uploader)
  const resultFromState = location.state?.result;

  // 2. If not available, get it from the Zustand store (for refresh)
  const resultFromStore = useProcessVuStore((state) =>
    documentId ? state.results[documentId] : null
  );
  const hasHydrated = useProcessVuStore((state) => state._hasHydrated);

  const result = resultFromState || resultFromStore;
  const projectName = location.state?.projectName;

  // Show loading indicator only when fetching from store after hydration
  if (!resultFromState && !hasHydrated) {
    return <div>결과를 로딩 중입니다...</div>;
  }

  // If after hydration, there's still no result, it's an error
  if (!documentId || !result) {
    return <div>결과를 찾을 수 없습니다.</div>;
  }

  return (
    <MainContainer>
      <Content $isCollapsed={isCollapsed}>
        <SideBar />
        <FlowLayoutContainer>
          <FlowHeader
            tags={VU_TAGS}
            projectId={projectId}
            initialName={projectName}
          />
          <FlowBody>
            <MediaSectionWrapper>
              <MediaFileSection projectId={"audion_vu"} result={result} />
            </MediaSectionWrapper>
            <ScriptContainer>
              <ScriptSection
                tabs={VU_TABS}
                initialTab="전체 텍스트"
                result={result}
                documentId={documentId}
              />
            </ScriptContainer>
          </FlowBody>
        </FlowLayoutContainer>
      </Content>
    </MainContainer>
  );
};

export default VoiceUnderstandingPage;
